import script from "./DeliveryForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryForm.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryForm.vue?vue&type=style&index=0&id=fd6402ba&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd6402ba"]])

export default __exports__